import { z } from 'zod';
import { groupScheme } from '@/models/group/group-info';
import { type RespondedType, responseScheme } from '@/models/response';
import { friendScheme } from '@/models/user/friend';
import { UserType } from '@/models/user/user-info';
import { avatarUrlSchema, nameSchema } from '@/utils/schemas';
import { genderSchema } from './common';

export const friendInfoScheme = z
  .object({
    FriendNickName: nameSchema,
    FriendHeadImg: avatarUrlSchema,
    FriendSign: nameSchema,
    FriendGender: genderSchema,
  })
  .merge(
    friendScheme.pick({
      ID: true,
      UserID: true,
      FriendID: true,
      RemarkName: true,
      IsOnline: true,
      OnlineDesc: true,
      Hide: true,
      Shield: true,
      Status: true,
      CreateTime: true,
      SortChar: true,
    }),
  );

export type FriendInfo = z.infer<typeof friendInfoScheme>;

export const friendInfoResponseScheme = z
  .object({
    FriendInfo: z.object({
      UID: z.number(),
      Type: z.lazy(() => z.nativeEnum(UserType)).catch(UserType.User),
      HeadImg: z.string(),
      NickName: z.string(),
      IsOnline: z.number().pipe(z.coerce.boolean()),
      OnlineDesc: z.string().optional(),
      RemarkName: z.string(),
      VChatID: z.string(),
      City: z.string(),
      Country: z.string(),
      Gender: z.number(),
      Province: z.string(),
      Sign: z.string(),
    }),
    CommonGroup: z.array(groupScheme).optional(),
    TagInfo: z.array(z.any()).optional(),
  })
  .merge(responseScheme);

export type FriendInfoResponseType = z.infer<typeof friendInfoResponseScheme> & RespondedType;
